import React from 'react';
import { motion } from 'framer-motion';
export function AnnouncementBar() {
  return <motion.div initial={{
    y: -50,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} className="bg-[#8B7355] text-[#FFF8F0] py-2 px-4 text-center text-sm font-medium tracking-wide z-50 relative" data-id="element-1">
      <p data-id="element-2">Oferta de lanzamiento por tiempo limitado · Acceso inmediato</p>
    </motion.div>;
}